<script>
    /**
     * 页面头部
     */
    import CommonHeader from 'southcn-ui2/src/components/widgets/CommonHeader';

    export default {
        name: 'common-header-wrap',
        props: {
            showSites: {
                type: Boolean,
                default: true
            },
            isExpand: {
                type: Boolean,
                default: false
            },
            type: {
                type: String,
                default: 'defaultText',
                require: false
            }
        },
        data () {
            return {
                hasNew: 0,
            };
        },
        created () {
        },
        components: {
            CommonHeader
        },
        watch: {},
        methods: {
            naviMessage () {
                window.open(this.getRightUrl(`${this.$store.state.appUrls.message_center_url}`));
            },
            naviAppCenter ($e) {
                window.open($e.link);
            },
            refreshSite (sites) {
                this.sites = sites.map(v => {
                    return {
                        ...v,
                        text: v.name,
                        value: v.id
                    };
                });
            },
            naviExit () {
                this.$bus.$emit('logout');
            },
            selectOpt ($e) {
                if ($e === 'personal') {
                    window.location.href = this.getRightUrl(`${this.$store.state.appUrls.personal_url}`, true);
                } else if ($e === 'manager') {
                    window.location.href = this.getRightUrl(`${this.$store.state.appUrls.mc_url}`);
                }
            },
            gotoUserCenter () {
                this.$router.push(`/${this.website.service_area_id}/${this.website.id}/personal`);
            },
            gotoIndex () {
                if (this.type === 'personal') {
                    return window.location.href = this.getRightUrl(`${this.$store.state.appUrls.uc_url}`, true);
                }
                this.$router.push(`/${this.website.service_area_id}/${this.website.id}/main`);
            },
            goAppCenter () {
                this.$router.push(`/${this.website.service_area_id}/${this.website.id}/appcenter`);
            },
            async selectUcSite (item) {
                let cache = item;
                item = item.pop();
                if (item !== this.website.id || item === 0) {
                    if (!item) {
                        const {more} = this.$util.getServiceList(this.$store.state.sites);
                        item = this.sites.filter(v => v.value === (cache[0] || 0))[0];
                        item = more ? item.children[0] : item;
                    } else {
                        item = this.$store.state.sites.filter(v => v.id === Number(item))[0];
                    }
                    // item = this.$store.state.sites.filter(v => v.id === item)[0];
                    item.routerName = this.$route.name;
                    item.params = this.$route.params;
                    item.query = this.$route.query;
                    item.is_new = true;
                    this.$storage(true).setItem('currentSite', item);
                    window.location.href = this.$config.webUrl.appPage;
                }
            },
            selectSite (item) {
                if (this.type === 'personal') {
                    item = this.sites.filter(v => Number(v.value) === item)[0];
                    if (item && item.org_id !== this.website.org_id) {
                        // currentSite只用于页面刷新时判断当前选择的站点
                        item.routerName = this.$route.name;
                        this.$storage(true).setItem('last-site', item);
                        window.location.href = this.$config.webUrl.adminPage;
                    }
                } else {
                    this.selectUcSite(item);
                }
            },
            getRightUrl (url, flag) {
                url = flag ? url : `${url}?source_app=usercenter`;
                const {id, service_area_id} = this.website;
                return url.replace('{$OID}', id).replace('{$AID}', service_area_id);
            }
        },
        computed: {
            withRight () {
                if (this.compText && (this.type !== 'register')
                    || this.$route.path.includes('/appcenter')) {
                    return true;
                }
                const mapText = {
                    personal: true,
                    defaultText: false,
                    register: false,
                    yyyy: true,
                };
                return mapText[this.type];
            },
            compText () {
                const path = this.$route.path;
                if (path.includes('/main')) {
                    return '首页';
                } else if (path.includes('/appcenter')) {
                    return '';
                } else if (path.includes('/inner/yxjk')) {
                    return '运行监控';
                } else if (path.includes('/inner/glkh')) {
                    return '管理考核';
                }
                const mapText = {
                    personal: '个人中心',
                    defaultText: '',
                    register: '用户注册'
                };
                return mapText[this.type];
            },
            sites () {
                return this.$store.state.serviceList;
            },
            user () {
                const user = this.$store.state.user;
                user.avatarUrl = user.img_url;
                return user;
            },
            dropDownOpt () {

                const personalOpt = {
                    text: '个人中心',
                    value: 'personal',
                    icon: '&#xe6bf;',
                };
                const logoutOpt = {
                    text: '退出登录',
                    value: 'logout',
                    isButton: true
                };
                if (!this.website.site_character || this.user.group <= 2) {
                    return [
                        personalOpt,
                        {
                            text: '管理中心',
                            value: 'manager',
                            icon: '&#xe6c0;',
                        },
                        logoutOpt
                    ];
                } else {
                    return [
                        personalOpt, logoutOpt
                    ];
                }
            },
            website () {
                return this.$store.state.website;
            },
            path () {
                const {appConfig} = this.$store.state;
                return [
                    {
                        name: appConfig.pt_name,
                        path: `${this.$store.state.appUrls.uc_url}`
                    }
                ];
            },
            msgNum () {
                return this.$store.state.message ? this.$store.state.message.count : 0;
            },
            appList () {
                const {website, appUrls} = this.$store.state;
                return website.appList;
            },
            showMessageCenter () {
                return !!this.$store.state.appConfig.topbar_message_enable;
            }
        }
    };
</script>

<template>
    <common-header :path="path"
                   :user="user"
                   :website="website"
                   :msgNum="msgNum"
                   :sites="sites"
                   :enable-auth-message="false"
                   :fixedDropDownOptionList="dropDownOpt"
                   :showSites="showSites"
                   :hideAppList="!showSites"
                   :userAppList="appList"
                   :withRight="withRight"
                   sourceApp="usercenter"
                   :appConfig="$store.state.appConfig"
                   @clickPath="gotoIndex"
                   @clickApp="naviAppCenter"
                   @selectFixDropDown="selectOpt"
                   @clickUserName="gotoUserCenter"
                   @selectSite="selectSite"
                   @clickLogo="gotoIndex"
                   @clickMessage="naviMessage"
                   @logout="naviExit">
        {{compText}}
    </common-header>
</template>

<style>

</style>

